const InitialState = { events: [], group: {}, select: {}, attr: {}, totalLayer: 0, loading: true, text: '' }

enum TypesFields {
    array = 'java.lang.Iterable',
    boolean = 'java.lang.Boolean',
    map = 'java.util.Map',
    number = 'java.lang.Double',
    object = 'java.lang.Object',
    string = 'java.lang.String'
}

export const reducer: WidgetReducerType<ChartState, ChartMessage> = (state = InitialState, message) => {
    if (!message) {
        return state
    }

    if (message.baseline && message.type !== 'event') {
        return state
    }

    const { type, layer, events } = message || {}

    switch (type) {
        case 'start':
            const { group, select = [], fields } = events
            const isChartValue = (field: string) => field != 'timestamp' && !isAttr(field)
            const isAttr = (field: string) => field.startsWith('__')
            const getFiledValue = (metric: string[], fieldType: TypesFields): string => {
                if (metric[0] == undefined) return ''

                if (metric[0] && isChartValue(metric[0])) {
                    return metric[0]
                } else {
                    return Object.entries(fields).find(([field, type]) => isChartValue(field) && type == fieldType)[0]
                }
            }

            return {
                ...state,
                events: [],
                group: getFiledValue(group, TypesFields.string),
                select: select.filter(e => isChartValue(e)),
                attr: Object.entries(fields).reduce((s, f) => (isAttr(f[0]) ? [...s, f[0]] : s), []) as string[]
            }

        case 'event':
            return {
                ...state,
                events: [...state.events, ...events]
            }
        case 'endHistory':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}
